(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ketoniq-editorial-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ketoniq-hero-26')) {
  customElements.define('ketoniq-hero-26', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.slides = Array.from(this.querySelectorAll('.kh26-slide'));
      this.dots = Array.from(this.querySelectorAll('.kh26-dot'));
      this.play = this.querySelector('[data-play]');
      this.status = this.querySelector('.kh26-status');
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.requestId = (this.requestId || 0) + 1;
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.editor = this.dataset.editor === 'true';
      this.paused = this.reduced.matches || this.editor;
      this.hovering = false;
      this.focusWithin = false;
      this.inView = true;
      if (!this.navigationDefaults) {
        this.navigationDefaults = {};
        ['--kh-nav-ink', '--kh-dot-ink', '--kh-dot-active'].forEach(key => {
          this.navigationDefaults[key] = this.style.getPropertyValue(key);
        });
      }
      const listen = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: this.abort.signal });
      listen(this, 'click', event => {
        const target = event.target.closest('button');
        if (!target || !this.contains(target)) return;
        if (target.hasAttribute('data-step')) this.go(this.index + Number(target.dataset.step), true);
        if (target.hasAttribute('data-slide')) this.go(Number(target.dataset.slide), true);
        if (target.hasAttribute('data-play')) {
          this.paused = !this.paused;
          this.updatePlay();
          this.schedule();
        }
      });
      listen(this, 'keydown', event => {
        if (event.target.closest('input, textarea, select') || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      listen(this, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovering = true; this.schedule(); } });
      listen(this, 'pointerleave', () => { this.hovering = false; this.schedule(); });
      listen(this, 'focusin', () => { this.focusWithin = true; this.schedule(); });
      listen(this, 'focusout', () => {
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.focusWithin = this.contains(document.activeElement);
          this.schedule();
        });
      });
      listen(this, 'pointerdown', event => {
        if (event.pointerType === 'mouse' || event.target.closest('a, button')) return;
        this.touch = { x: event.clientX, y: event.clientY, id: event.pointerId };
      });
      listen(this, 'pointerup', event => {
        if (!this.touch || this.touch.id !== event.pointerId) return;
        const dx = event.clientX - this.touch.x;
        const dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) this.go(this.index + (dx < 0 ? 1 : -1), true);
      });
      listen(this, 'pointercancel', () => { this.touch = null; });
      listen(document, 'visibilitychange', () => this.schedule());
      listen(window, 'resize', () => this.queueLayout());
      listen(this.mobile, 'change', () => this.queueLayout());
      listen(this.reduced, 'change', () => {
        if (this.reduced.matches) this.paused = true;
        this.updatePlay();
        this.schedule();
      });
      listen(document, 'shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId || slide.dataset.paletteBlockId === event.detail?.blockId);
        if (index >= 0) this.go(index, true);
      });
      this.slides.forEach(slide => {
        const image = slide.querySelector('img');
        if (image) listen(image, 'load', () => this.queueLayout());
      });
      this.resizeObserver = new ResizeObserver(() => this.queueLayout());
      this.resizeObserver.observe(this);
      this.querySelectorAll('.kh26-action').forEach(action => this.resizeObserver.observe(action));
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.05 });
      this.intersectionObserver.observe(this);
      this.layout();
      this.setNavigation();
      this.updatePlay();
      const controls = this.querySelector('.kh26-controls');
      if (controls) controls.hidden = false;
      this.warmNext();
      this.schedule();
    }

    disconnectedCallback() {
      this.ready = false;
      this.requestId += 1;
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      clearTimeout(this.timer);
      cancelAnimationFrame(this.layoutFrame);
    }

    queueLayout() {
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => this.layout());
    }

    layout() {
      if (!this.isConnected) return;
      const viewportWidth = document.documentElement.clientWidth;
      const widthValue = `${viewportWidth}px`;
      if (this.style.getPropertyValue('--kh-viewport-width') !== widthValue) this.style.setProperty('--kh-viewport-width', widthValue);
      const w = this.clientWidth;
      const h = this.clientHeight;
      if (!w || !h) return;
      const mobile = this.mobile.matches;
      this.setNavigation();
      this.slides.forEach(slide => {
        const image = slide.querySelector('img');
        let rect = { x: 0, y: 0, w, h };
        if (slide.dataset.reference === 'image' && image?.naturalWidth && image?.naturalHeight) {
          const fit = mobile ? slide.dataset.fitMobile : slide.dataset.fit;
          const scale = (fit === 'contain' ? Math.min : Math.max)(w / image.naturalWidth, h / image.naturalHeight);
          const iw = image.naturalWidth * scale;
          const ih = image.naturalHeight * scale;
          const fx = Number(mobile ? slide.dataset.focalXMobile : slide.dataset.focalX) / 100;
          const fy = Number(mobile ? slide.dataset.focalYMobile : slide.dataset.focalY) / 100;
          rect = { x: (w - iw) * fx, y: (h - ih) * fy, w: iw, h: ih };
        }
        slide.querySelectorAll('.kh26-action').forEach(action => {
          const x = Number(mobile ? action.dataset.xMobile : action.dataset.x) / 100;
          const y = Number(mobile ? action.dataset.yMobile : action.dataset.y) / 100;
          const halfWidth = action.offsetWidth / 2;
          const halfHeight = action.offsetHeight / 2;
          const insetX = Math.min(w / 2, halfWidth + 16);
          const insetY = Math.min(h / 2, halfHeight + 16);
          const left = Math.max(insetX, Math.min(w - insetX, rect.x + rect.w * x));
          const top = Math.max(insetY, Math.min(h - insetY, rect.y + rect.h * y));
          action.style.left = `${left}px`;
          action.style.top = `${top}px`;
        });
      });
    }

    async go(requested, userInitiated = false) {
      if (this.slides.length < 2) return;
      const next = (requested + this.slides.length) % this.slides.length;
      const requestId = ++this.requestId;
      clearTimeout(this.timer);
      if (userInitiated) {
        this.paused = true;
        this.updatePlay();
      }
      const image = this.slides[next].querySelector('img');
      if (image) {
        image.loading = 'eager';
        if (!image.complete && image.decode) {
          try { await image.decode(); } catch (_) {}
        }
      }
      if (!this.isConnected || requestId !== this.requestId) return;
      const oldSlide = this.slides[this.index];
      if (next !== this.index && oldSlide?.contains(document.activeElement)) {
        const destination = this.dots[next] && this.dataset.dots !== 'false' ? this.dots[next] : this.querySelector('[data-step="1"]');
        if (destination && destination.getClientRects().length) destination.focus({ preventScroll: true });
        else document.activeElement.blur();
      }
      this.index = next;
      this.slides.forEach((slide, i) => {
        const active = i === next;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === next)));
      this.setNavigation();
      this.layout();
      if (userInitiated && this.status) this.status.textContent = this.slides[next].getAttribute('aria-label');
      this.warmNext();
      this.schedule();
    }

    setNavigation() {
      const slide = this.slides[this.index];
      const mobile = this.mobile.matches;
      const values = { '--kh-nav-ink': (mobile && slide?.dataset.navInkMobile) || slide?.dataset.navInk, '--kh-dot-ink': (mobile && slide?.dataset.dotInkMobile) || slide?.dataset.dotInk, '--kh-dot-active': (mobile && slide?.dataset.dotActiveMobile) || slide?.dataset.dotActive };
      Object.entries(values).forEach(([key, value]) => this.style.setProperty(key, value || this.navigationDefaults[key]));
    }

    warmNext() {
      if (this.slides.length < 2) return;
      const image = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
      if (image) image.loading = 'eager';
    }

    updatePlay() {
      if (!this.play) return;
      this.play.classList.toggle('is-paused', this.paused);
      this.play.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
    }

    schedule() {
      clearTimeout(this.timer);
      if (!this.ready || !this.isConnected || this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.paused || this.editor || this.hovering || this.focusWithin || !this.inView || document.hidden) return;
      this.timer = setTimeout(() => this.go(this.index + 1), Math.max(3000, Number(this.dataset.interval) || 6000));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
